/**
 * Vue i18n
 *
 * @library
 *
 * http://kazupon.github.io/vue-i18n/en/
 */

// Lib imports
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/lang'

Vue.use(VueI18n)

const dateTimeFormats = {
    'en': {
        short: {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        },
        long: {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            weekday: 'short',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        }
    },
    'ru': {
        short: {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        },
        long: {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'short',
            hour: 'numeric',
            minute: 'numeric'
        }
    }
}

const fallbackLocale = 'en'

const getLocale = () => {
    const ALLOWED_LOCALES = ['en', 'ru'];
    const userLocale = navigator.language.split('-')[0];
    return localStorage.getItem('language') || (ALLOWED_LOCALES.includes(userLocale) ? userLocale : fallbackLocale)
}

const i18n = new VueI18n({
    dateTimeFormats,
    locale: getLocale(),
    fallbackLocale,
    messages
})

export default i18n
